import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { objectToUrlParams, TreetopPropertiesProvider } from 'shared/util-common';

import { UnitDto } from '@treetop/shared/model';

import { MessagesService } from './messages.service';
import { convertParamsToCompatibleUnitQuery, convertParamsToConvertUnitQuery } from './UnitQueryResolver';

@Injectable({
  providedIn: 'root',
})
export class UnitService {
  private http = inject(HttpClient);
  private messages = inject(MessagesService);
  private router = inject(Router);

  baseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api`;

  getCompatibleUnits(unitCode: string, isMolarMassAvailable: boolean): Observable<UnitDto[]> {
    const compatibleUnitQuery = convertParamsToCompatibleUnitQuery(unitCode, isMolarMassAvailable);
    const compatibleUnitParams = objectToUrlParams(compatibleUnitQuery);
    return this.http.get<UnitDto[]>(`${this.baseUrl}/units/compatible?${compatibleUnitParams}`).pipe(
      map((result) => {
        return result;
      }),
      catchError((error: HttpErrorResponse) => {
        this.messages.showError('CouldNotGetCompatibleUnits');
        return throwError(() => error);
      }),
      shareReplay(),
    );
  }

  public getConvertedUnit(value: number, fromUnitCode: string, toUnitCode: string, molarMass?: number): Observable<number> {
    if (molarMass) {
      return this.getConvertedUnitWithMolarMass(value, fromUnitCode, toUnitCode, molarMass);
    }

    const convertibleUnitQuery = convertParamsToConvertUnitQuery(value, fromUnitCode, toUnitCode);
    const convertibleUnitParams = objectToUrlParams(convertibleUnitQuery);
    return this.http.get<number>(`${this.baseUrl}/units/convert?${convertibleUnitParams}`).pipe(
      map((result) => {
        return result;
      }),
      catchError((error: HttpErrorResponse) => {
        this.messages.showError('CouldNotGetConvertedUnit');
        return throwError(() => error);
      }),
      shareReplay(),
    );
  }

  private getConvertedUnitWithMolarMass(value: number, fromUnitCode: string, toUnitCode: string, molarMass: number): Observable<number> {
    const convertibleUnitQuery = convertParamsToConvertUnitQuery(value, fromUnitCode, toUnitCode, molarMass);
    const convertibleUnitParams = objectToUrlParams(convertibleUnitQuery);
    return this.http.get<number>(`${this.baseUrl}/units/convert?${convertibleUnitParams}`).pipe(
      map((result) => {
        return result;
      }),
      catchError((error: HttpErrorResponse) => {
        this.messages.showError('CouldNotGetConvertedUnit');
        return throwError(() => error);
      }),
      shareReplay(),
    );
  }
}
